import { Link } from 'react-router-dom';
import PageMeta from '../components/PageMeta';
import './AccountDeletionPage.css';

const DELETABLE_DATA = [
  'Hesap bilgileriniz',
  'E-posta adresiniz',
  'Profil bilgileriniz',
  'Kullanıcı tarafından yüklenen ders notları',
  'Notlarla ilişkili bölüm, ders ve dönem bilgileri',
  'Kullanıcıya ait uygulama içi kayıtlar',
];

const STEPS = [
  { text: 'noteswapp@gmail.com adresine e-posta gönderin.', email: true },
  { text: 'E-posta konu başlığına “NoteSwapp Hesap Silme Talebi” yazın.' },
  { text: 'Mesaj içinde NoteSwapp hesabınızda kullandığınız e-posta adresini belirtin.' },
  { text: 'Talebiniz incelendikten sonra hesabınız ve hesabınızla ilişkili veriler silme sürecine alınır.' },
];

export default function AccountDeletionPage() {
  return (
    <div className="account-deletion-page">
      <PageMeta
        title="NoteSwapp Hesap ve Veri Silme Talebi"
        description="NoteSwapp kullanıcıları hesaplarının ve ilişkili verilerinin silinmesini bu sayfa üzerinden nasıl talep edebileceklerini öğrenebilir."
      />

      <section className="account-deletion-hero">
        <div className="container">
          <p className="account-deletion-hero__tag">NoteSwapp · Gizlilik</p>
          <h1 className="account-deletion-hero__title">Hesap ve Veri Silme Talebi</h1>
          <p className="account-deletion-hero__subtitle">
            NoteSwapp kullanıcıları, hesaplarının ve hesaplarıyla ilişkili kişisel verilerinin silinmesini talep
            edebilir. Ayrıca kullanıcılar hesaplarını tamamen silmeden, yalnızca belirli verilerinin veya yükledikleri
            ders notlarının silinmesini de isteyebilir.
          </p>
          <a href="mailto:noteswapp@gmail.com?subject=NoteSwapp%20Hesap%20Silme%20Talebi" className="account-deletion-hero__cta">
            Silme talebi gönder
          </a>
        </div>
      </section>

      <section className="account-deletion-content">
        <div className="container account-deletion-grid">
          <article className="account-deletion-card">
            <h2>Hesap silme talebi nasıl yapılır?</h2>
            <p className="account-deletion-card__lead">
              Hesabınızı silmek için aşağıdaki adımları izleyebilirsiniz:
            </p>
            <ol className="account-deletion-steps">
              {STEPS.map((step, i) => (
                <li key={i}>
                  {step.email ? (
                    <>
                      <a href="mailto:noteswapp@gmail.com">noteswapp@gmail.com</a> adresine e-posta gönderin.
                    </>
                  ) : (
                    step.text
                  )}
                </li>
              ))}
            </ol>
          </article>

          <article className="account-deletion-card">
            <h2>Silinebilecek veriler</h2>
            <p className="account-deletion-card__lead">
              Hesap silme talebiniz kapsamında aşağıdaki veriler silinebilir:
            </p>
            <ul className="account-deletion-list">
              {DELETABLE_DATA.map(item => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </article>

          <article className="account-deletion-card">
            <h2>Kısmi veri silme talebi</h2>
            <p>
              Hesabınızı tamamen silmeden yalnızca belirli verilerinizin veya yüklediğiniz notların silinmesini de
              talep edebilirsiniz. Bunun için{' '}
              <a href="mailto:noteswapp@gmail.com?subject=NoteSwapp%20Veri%20Silme%20Talebi">noteswapp@gmail.com</a>{' '}
              adresine &quot;NoteSwapp Veri Silme Talebi&quot; başlığıyla e-posta gönderebilirsiniz.
            </p>
          </article>

          <article className="account-deletion-card">
            <h2>Saklanabilecek veriler</h2>
            <p>
              Bazı teknik kayıtlar, güvenlik, kötüye kullanımın önlenmesi veya yasal yükümlülükler nedeniyle sınırlı
              süreyle saklanabilir. Bu veriler yalnızca gerekli olduğu süre boyunca saklanır ve daha sonra silinir veya
              anonimleştirilir.
            </p>
          </article>

          <article className="account-deletion-card account-deletion-card--contact">
            <h2>İletişim</h2>
            <p>
              Hesap silme, veri silme veya gizlilikle ilgili tüm talepleriniz için bizimle{' '}
              <a href="mailto:noteswapp@gmail.com">noteswapp@gmail.com</a> adresi üzerinden iletişime geçebilirsiniz.
            </p>
            <p className="account-deletion-card__links">
              İlgili metinler:{' '}
              <Link to="/gizlilik-politikasi">Gizlilik Politikası</Link>
              {' · '}
              <Link to="/kvkk">KVKK Aydınlatma Metni</Link>
            </p>
          </article>
        </div>
      </section>
    </div>
  );
}
